import React, { useState } from 'react'

// Deps
// import { connect } from 'react-redux'

// Partials
import Btn from 'views/shared/partials/btn'
import Image from 'views/shared/partials/image'
import QuantityInput from 'views/shared/partials/quantity-input'
import Pricebox from 'views/shared/partials/pricebox'
// import Collapser from 'views/shared/partials/collapser'
import { InputForm, FormInput } from 'views/shared/partials/forms'

// Utils
import { openModal } from 'utils/modals'

// Services
// import orderServices from 'services/order'
// import commerceServices from 'services/commerce'

const ReturnOrderProductModal = ({orderData, close, onSuccess, ...props}) => {
	// const [submitting, setSubmitting] = useState(false);
	const [returnData, setReturnData] = useState({total: 0, products: {}})

	const submit = (formData) => {
		// setSubmitting(true);

		let returnProducts = [];
		let returnProductsList = [];
		let leftProducts = [];
		let newTotal = 0;

		for (const prod of orderData.products) {
			if (prod.status === 1) {
				leftProducts.push(prod.product_id);
				newTotal += parseFloat(prod.product.price);
			}
		}

		for (const typeid in returnData.products) {
			const product = returnData.products[typeid];
			for (let k = 0; k < product.ids.length; k++) {
				const uniqueid = product.ids[k];
				leftProducts.splice(leftProducts.indexOf(product.product.id), 1);
				newTotal -= parseFloat(product.product.price);
				returnProducts.push({
					basket_id: uniqueid,
					refund_reason: product.individualMessages ? formData['message_' + uniqueid] : formData['message_' + product.ids[0]],
					// product_id: typeid,
					// price: product.basePrice,
				})

				returnProductsList.push({
					...product,
					refund_reason: product.individualMessages ? formData['message_' + uniqueid] : formData['message_' + product.ids[0]],
					return_price: product.prices[k],
				})
			}
		}

		const remainingAmount = parseFloat(orderData.remaining_amount);

		// commerceServices.previewRefund({
		// 	refund_price: returnData.total.toFixed(2),
		// 	// products: JSON.stringify(returnProducts),
		// 	order_business_code: orderData.business_order_code,
		// 	add_ratio: 1,
		// 	refund_reason: 'Çoklu iade',
		// }).then((payload) => {
		// })

		// openModal('return-order-product-summary', {
		// 	top: true,
		// 	productList: returnProductsList,
		// 	returnData: returnData,
		// 	returnAmount: (returnData.total > remainingAmount ? returnData.total - remainingAmount : 0),
		// 	refunds: [
		// 		{
		// 			success: true,
		// 			process: {
		// 				payment: {
		// 					approve_code: "929650",
		// 					card_expiry_date: "0333",
		// 					card_masked: "5504720******0003",
		// 					card_name: "Osmantan Erkır",
		// 					client_order_id: 1587,
		// 					created_at: "2020-12-31 10:18:26",
		// 					currency_exchange_rate: null,
		// 					currency_exchange_rate_id: null,
		// 					currency_exchange_refund_total: null,
		// 					currency_exchange_total: null,
		// 					error_code: null,
		// 					error_message: null,
		// 					id: 2377,
		// 					installment_count: 1,
		// 					integrated_at: null,
		// 					integrated_id: null,
		// 					is_3d: true,
		// 					order: { id: 1587, company_id: 2, client_id: 504, company_account_id: 66, company_store_id: 306 },
		// 					payment_name: "Odedim.com",
		// 					payment_type: { id: 8, type: 1, name: "Odedim.com", payment_code: "iyzico" },
		// 					payment_type_id: 8,
		// 					price: "250.00",
		// 					real_price: "250.00",
		// 					refund_real_total: "0",
		// 					refund_total: "0",
		// 					status: 1,
		// 				},
		// 				refund_price: '248.22',
		// 				refund_price_real: '253.29'
		// 			}
		// 		},
		// 		{
		// 			success: false,
		// 			process: {
		// 				payment: {
		// 					approve_code: "929650",
		// 					card_expiry_date: "0333",
		// 					card_masked: "5504720******0003",
		// 					card_name: "Osmantan Erkır",
		// 					client_order_id: 1587,
		// 					created_at: "2020-12-31 10:18:26",
		// 					currency_exchange_rate: null,
		// 					currency_exchange_rate_id: null,
		// 					currency_exchange_refund_total: null,
		// 					currency_exchange_total: null,
		// 					error_code: null,
		// 					error_message: null,
		// 					id: 2377,
		// 					installment_count: 1,
		// 					integrated_at: null,
		// 					integrated_id: null,
		// 					is_3d: true,
		// 					order: { id: 1587, company_id: 2, client_id: 504, company_account_id: 66, company_store_id: 306 },
		// 					payment_name: "Odedim.com",
		// 					payment_type: { id: 8, type: 1, name: "Odedim.com", payment_code: "iyzico" },
		// 					payment_type_id: 8,
		// 					price: "250.00",
		// 					real_price: "250.00",
		// 					refund_real_total: "0",
		// 					refund_total: "0",
		// 					status: 1,
		// 				},
		// 				refund_price: '248.22',
		// 				refund_price_real: '253.29'
		// 			}
		// 		},
		// 		{
		// 			success: false,
		// 			process: {
		// 				payment: {
		// 					approve_code: "929650",
		// 					card_expiry_date: "0333",
		// 					card_masked: "5504720******0003",
		// 					card_name: "Osmantan Erkır",
		// 					client_order_id: 1587,
		// 					created_at: "2020-12-31 10:18:26",
		// 					currency_exchange_rate: null,
		// 					currency_exchange_rate_id: null,
		// 					currency_exchange_refund_total: null,
		// 					currency_exchange_total: null,
		// 					error_code: null,
		// 					error_message: null,
		// 					id: 2377,
		// 					installment_count: 1,
		// 					integrated_at: null,
		// 					integrated_id: null,
		// 					is_3d: true,
		// 					order: { id: 1587, company_id: 2, client_id: 504, company_account_id: 66, company_store_id: 306 },
		// 					payment_name: "Odedim.com",
		// 					payment_type: { id: 8, type: 1, name: "Odedim.com", payment_code: "iyzico" },
		// 					payment_type_id: 8,
		// 					price: "250.00",
		// 					real_price: "250.00",
		// 					refund_real_total: "0",
		// 					refund_total: "0",
		// 					status: 1,
		// 				},
		// 				refund_price: '248.22',
		// 				refund_price_real: '253.29'
		// 			}
		// 		}
		// 	]
		// })

		openModal('return-order-product-preview', {
			top: true,
			orderData: orderData,
			leftProducts: leftProducts,
			returnProducts: returnProducts,
			productList: returnProductsList,
			returnData: returnData,
			onSuccess: (payload) => {
				onSuccess();
				setTimeout(() => {
					openModal(
						'return-order-product-summary', {
							top: true,
							productList: returnProductsList,
							returnData: returnData,
							returnAmount: (returnData.total > remainingAmount ? returnData.total - remainingAmount : 0),
							refunds: payload.refunds,
						})
				}, 1000)
				close();
			},
			newTotal: parseFloat(newTotal.toFixed(2)),
			returnAmount: (returnData.total > remainingAmount ? returnData.total - remainingAmount : 0),
		});


		// commerceServices.createOrder({
		// 	order_business_code: orderData.business_order_code,
		// 	client_code: orderData.client.client_code,
		// 	order_store_code: orderData.group.store_code,
		// 	order_price_type_id: orderData.price_type_id,
		// 	order_target_store_code: orderData.target_group.store_code,
		// 	product_id: leftProducts
		// }).then((posMockPayload) => {
		// 	if(posMockPayload.refund_plan && posMockPayload.refund_plan.length) {
		// 	}
		// 	else {
		// 		openModal('message', {
		// 			message: 'Seçtiğiniz ürünler başarılı bir şekilde iade edildi.',
		// 			top: true,
		// 		})
		// 		onSuccess();
		// 		props.close();
		// 	}
		// }).catch(() => {
		// 	setSubmitting(false);
		// })

		// orderServices.refundPayment({
		// 	refund_price: parseFloat(returnData.total),
		// 	products: JSON.stringify(returnProducts),
		// 	order_business_code: orderData.business_order_code,
		// 	add_ratio: 1,
		// 	refund_reason: 'Çoklu iade',
		// }).then((payload) => {
		// 	onSuccess();
		// 	close();
		// }).catch(() => {
		// }).finally(() => {
		// 	setSubmitting(false);
		// })
	}

	const quantityChange = (product, quantity) => {
		let productPrice = parseFloat(product.price_new.replace(',', '.'));
		const productID = product.id;

		let newReturnData = {
			...returnData,
			total: returnData.total - (returnData.products[productID] ? (productPrice * returnData.products[productID].quantity) : 0)};

		if(quantity !== 0) {
			// let ids = [];

			// for(let k = 0; k < quantity; k++) {
			// 	ids.push((newReturnData[productID] && newReturnData[productID].ids[k]) ? newReturnData[productID].ids[k] : '');
			// }

			let newPrices = [];

			for(let k = 0; k < quantity; k++) {
				newPrices.push(product.price_new);
			}

			newReturnData.products[productID] = {
				quantity: quantity,
				individualMessages: newReturnData[productID] ? newReturnData[productID].individualMessages : false,
				ids: product.ids.slice(0, quantity),
				prices: newPrices,
				basePrice: productPrice,
				product: product.product,
			}

			newReturnData.total += productPrice * quantity;
		}
		else if(newReturnData.products[productID]) {
			delete newReturnData.products[productID];
		}

		setReturnData(newReturnData);
	}

	const individualMessagesChange = (product, status) => {
		const newStatus = status ? true : false;

		if(returnData.products[product.id].individualMessages !== newStatus) {
			setReturnData({
				...returnData,
				products: {
					...returnData.products,
					[product.id]: {
						...returnData.products[product.id],
						individualMessages: newStatus,
					}
				}
			})
		}
	}

	return (
		<InputForm
			ignoreEmpty
			onSubmit={submit}
			className={props.className}>
			<div className="modal-header dark">
				<h1 className="header-title">Ürün İadesi</h1>
				{props.closeBtn}
			</div>

			<div className="modal-content">
				<p className="return-message">İade Etmek İstediğiniz Ürün Miktarlarını Seçin</p>

				<ul className="modal-group return-products">
					{orderData.parsedProducts.active.map((product, nth) => (
						<li key={nth} className="products-product">
							<div className="product-controls">
								<div className="controls-info">
									<div className="info-imagewrap">
										<Image src={product.product.image_link} className="info-image" />
									</div>
									<div className="info-text">
										<strong className="text-title">
											{product.product.title}
										</strong>
										<p className="text-mpn">{product.product.mpn}</p>
									</div>
								</div>
								<div className="controls-counter">
									<QuantityInput
										max={product.quantity}
										onChange={(val) => { quantityChange(product, val) }}
										value={returnData.products[product.id] ? returnData.products[product.id].quantity : 0} />
								</div>
							</div>
							{(returnData.products[product.id] && returnData.products[product.id].ids.length > 0) &&
								<div className="product-data grid-container">
									{returnData.products[product.id].ids.length > 1 &&
										<div className="row">
											<div className="col">
												<FormInput
													type="checkbox"
													name={'is_individual_' + product.id}
													value="1"
													onChange={(val) => { individualMessagesChange(product, val); }}
													label="Her ürün için ayrı iade sebebi gir." />
											</div>
										</div>
									}
									{returnData.products[product.id].ids.map((uniqueid, mnth) => (
										<div className="row low" key={mnth}>
											<div className="col flex data-productinfo">
												<strong className="">{mnth+1}. Ürün:</strong>
												<p className="productinfo-id">#{uniqueid}</p>
											</div>
											<div className="col x7">
												{(returnData.products[product.id].individualMessages || mnth < 1) &&
													<FormInput
														name={'message_'+uniqueid}
														validation={{
															required: 'Ürünler için birer iade sebebi girmelisiniz.'
														}}
														type="textarea"
														rows="1"
														label="İade Sebebi"
														placeholder="Bir iade sebebi girin."
														key={nth+'-'+mnth} />
												}
											</div>
											<div className="col x3">
												<FormInput
													label="Ürün Tutarı"
													name={'price_' + uniqueid}
													decimals="2"
													readOnly
													value={returnData.products[product.id].prices[mnth]}
													type="number" />
											</div>
										</div>
									))}
								</div>
							}
						</li>
					))}
				</ul>

				<div className="modal-group wide return-sum">
					<strong>İade Toplamı</strong>
					<Pricebox big price={returnData.total} />
				</div>
			</div>

			<div className="modal-controls">
				<Btn
					nude
					onClick={close}>
					Vazgeç
				</Btn>
				<Btn
					disabled={returnData.total === 0}
					type="submit">
					Devam
				</Btn>
			</div>
		</InputForm>
	)
}

ReturnOrderProductModal.defaultProps = {
	className: '',
	containerClass: 'modal-return-order-product mobile-full',
	name: 'return-order-product',
}

export default ReturnOrderProductModal